import { getCgiDefaultParamsValue } from "../../common/schemaUtil";
import { FORM_INFOS } from "../formMethods/formInfos";
import { getObjectJSONString } from "../utils/code";
import { defaultMethodConfig } from "../utils/consts";
import { invokeAndLogDebugCode, selectConfig } from "./common";
const getAnyCode = options => {
  var _options$collection$c;
  const cgiInfo = (_options$collection$c = options.collection.cgiInfo) === null || _options$collection$c === void 0 ? void 0 : _options$collection$c.request;
  const postParams = (cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.type) === 'post' ? ',\nbody:source.body' : '';
  const {
    isSql
  } = options;
  const write = `
  // 写入页面数据
  source.data = body;
`;
  const content = isSql ? `
  if(body.code === 0) {
    ${write.trim()}
  }else{
    $message.error(body.message);
  }
` : write;
  const code = `
async ( ) => {
  try {
    // 调用any接口
    const { body } = await source.$requests.request({
      query:source.query${postParams}
    });

  ${content.trim()}

    return body;
  } catch (e) {
    $tips.error({
      content: e.message
    })
  }
}
  `;
  return {
    args: [],
    code
  };
};
export function generateAnyMethod(options) {
  const config = selectConfig(options, getAnyCode, FORM_INFOS.any.request);
  return {
    id: 'request',
    title: '请求request接口',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
const getCustomCode = options => {
  const {
    collection,
    cgi
  } = options;
  const params = getCgiDefaultParamsValue(collection, cgi);
  const cgiInfo = collection.cgiInfo[cgi];
  if ((cgiInfo === null || cgiInfo === void 0 ? void 0 : cgiInfo.type) === 'get') {
    delete params.body;
  }
  const code = `
async ( ) => {
  try {
    // 调用接口
    const { body } = await source.$requests.${cgi}(${getObjectJSONString(params)});

    // 写入页面数据
    $set(source.customState,'${cgi}',body);

    return body;
  } catch (e) {
    $tips.error({
      content: e.message
    })
  }
}`;
  return {
    args: [],
    code
  };
};
export function generateCustomMethod(options) {
  const {
    cgi
  } = options;
  const config = selectConfig(options, getCustomCode, FORM_INFOS.custom);
  return {
    id: cgi,
    title: `请求${cgi}接口`,
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
//# sourceMappingURL=any.js.map
